
	import { defineComponent, PropType } from 'vue';

	import FiscalYearReport from '@/ChildrenComponents/Reports/FiscalYearReport.vue';

	import { IFiscalYearReportByParticipant, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

	export default defineComponent({
		name: 'fiscal-year-report-by-participant',
		components: { FiscalYearReport },
		props: {
			title: { type: String, required: true },
			filename: { type: String, required: true },
			isSearching: { type: Boolean, required: true },
			reportData: { type: Object as PropType<IFiscalYearReportByParticipant[]>, required: true },
		},
		emits: ["search"],
		data () {
			return {
				reportHeaders: [
                    { title: "Program", key: "treatmentProgram", sortable: true, align: "start" },
					{ title: "Participant ID", key: "participantId", sortable: true, align: "start" },
					{ title: "Last Name", key: "lastName", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			search(searchDto: IFiscalYearReportSearch) {
				this.$emit("search", searchDto);
			}
		},
	});
